// extracted by mini-css-extract-plugin
var _1 = "webpack-concepts-Extraction-Blocks-shared-DeleteBlockWarningDialog-module__modalFooter";
export { _1 as "modalFooter" }
